'use client';

import { useEffect } from 'react';

import { useToggle } from '@nf/utils-common/hooks';
import { uiService } from '@/services/ui.service';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useLayoutSegmentsMatched } from '@/hooks/use-layout-segments-matched';
import { useCurrentProperties } from '@/hooks/query';
import { SINGLE_SPORT_MENU_MODE } from '@/constants/sport-menu-mode';

export const SportsbookLayoutContainer = ({ 
	children 
}: { 
	children: React.ReactNode 
}) => {
	
	const [isSidebarOpen, toggleSidebarOpen, setIsSidebarOpen] = useToggle();
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();
	const view = useAppearanceStore(state => state.view);
	const { eventMode } = useCurrentProperties();
	const isSingleSportMenuModeId = SINGLE_SPORT_MENU_MODE.includes(eventMode);
	const isNoSportsMenuPage = (useLayoutSegmentsMatched(['favorites', 'section']) && view === ViewEnum.galaxy) || isSingleSportMenuModeId;
	const isNoBetCategoryBarPage = (useLayoutSegmentsMatched(['favorites', 'section']) && view === ViewEnum.galaxy);

	useEffect(() => {
		const subscription = uiService.onControlSidebarButton$.subscribe(shouldOpenSidebar => {
			setIsSidebarOpen(shouldOpenSidebar);
		});

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	return (
		<div 
			className="main-container"
			data-open-left-menu={isSidebarOpen}
			data-no-header={view === ViewEnum.galaxy && siteConfig?.EnableHeadlessForGalaxy ? true : undefined}
			data-no-sports-menu={isNoSportsMenuPage ? true : undefined}
			data-no-bet-category-bar={isNoBetCategoryBarPage ? true : undefined}
		>
			{children}
		</div>
	);
}